import React, { FC } from 'react';

import { Form, Select } from 'antd';
import { Label } from 'ui';
import { formRules } from 'utils/formRules';

import FieldToSave from '../web-hook-fields-to-save';
import s from './SaveContact.module.scss';

export const defaultFieldValue = {
  FIRSTNAME: 'First Name',
  LASTNAME: 'Last Name',
  MOBILENUMBER: 'Mobile Number',
  NOOFTICKETS: 'No of tickets',
  ORDERTOTAL: 'Order Total',
};

interface SaveContactProps {
  fields?: {
    caption: string;
    value: string;
  }[];
  setFields: (
    fields: {
      caption: string;
      value: string;
    }[],
  ) => void;
}

const SaveContact: FC<SaveContactProps> = ({ setFields, fields }) => {
  return (
    <div className={s.wrapper}>
      {' '}
      <div className={s.row}>
        <div className={s.item}>
          <Label required>Contact Provider</Label>
          <Form.Item name="contactProvider" initialValue="Breevo" rules={[formRules.required]}>
            <Select
              style={{ width: '100%', height: 40 }}
              options={[{ value: 'Breevo', label: 'Breevo' }]}
            />
          </Form.Item>
        </div>
      </div>
      <div className={s.row}>
        <div className={s.item}>
          <FieldToSave fields={fields} setFields={setFields} />
        </div>
      </div>
    </div>
  );
};

export default SaveContact;
